import { inject, injectable } from '@servicetitan/react-ioc';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { FeBundleApi } from '../api/fe-bundle.api';
@injectable()
export class FeBundleStore {
    @observable
    feLoading = false;

    @observable
    bundleUrl?: string = '';

    @observable
    isError = false;

    constructor(@inject(FeBundleApi) private readonly feBundleApi: FeBundleApi) {
        makeObservable(this);
    }

    @action
    init = async (isPilot: boolean) => {
        try {
            this.feLoading = true;
            const url = await this.feBundleApi.getPackageUrl(isPilot);

            runInAction(() => {
                this.bundleUrl = url.data;
            });
        } catch {
            runInAction(() => {
                this.isError = false;
            });
        } finally {
            runInAction(() => {
                this.feLoading = false;
            });
        }
    };
}
